import React from 'react';
import { ArrowLeft } from 'react-feather';
import Image from 'next/image';

import { Box, Link, Text } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

type BoxImageProps = {
  image: string;
  alt: string;
  style?: React.CSSProperties;
  title: string;
  code: string;
};
const BoxImage: React.FC<BoxImageProps> = ({ image, alt, style, code }) => {
  const { t } = useTranslation('pages.home');

  return (
    <Box
      position="relative"
      display="block"
      width="100%"
      aspectRatio={257 / 247}
      sx={{
        img: {
          objectFit: 'cover',
          borderRadius: '8px',
        },
      }}
      style={style}
      as={Link}
      href={routes.blog.href(code)}
      overflow={'hidden'}
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        zIndex={2}
      />
      <Image
        src={image}
        fill
        alt={alt}
        sizes="(min-width: 90em) 268px, (min-width: 80em) calc((100vw - 104px) / 5), (min-width: 62em) calc((100vw - 40px) / 3), (min-width: 48em) calc((100vw - 30px) / 2), calc(100vw - 20px)"
      />

      <Box
        position="absolute"
        bottom={'10px'}
        width="100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        zIndex={2}
        color="white"
        textAlign="center"
        px={2}
      >
        <Box
          background={'rgba(255, 255, 255, 0.5)'}
          width={'120px'}
          height="40px"
          borderRadius={'16px'}
          backdropBlur={4}
          display={'flex'}
          justifyContent={'center'}
          backdropFilter="blur(4px)"
          alignItems={'center'}
        >
          <Text
            fontWeight="800"
            fontSize="16px"
            display={'flex'}
            alignItems="center"
          >
            {t('view')}
            <ArrowLeft
              width={12}
              fontWeight="800"
              style={{ marginRight: '10px' }}
            />
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
export default BoxImage;
